import { jsxs as a, jsx as e } from "react/jsx-runtime";
import t from "./Card.js";
import l from "./Icon.js";
import { H as r } from "./chunks/index-UjijAVoZ.js";
import { I as s } from "./chunks/index-CgDhSQ6a.js";
const d = () => /* @__PURE__ */ a("div", { className: "container-xl flex flex-col gap-6 tablet:gap-7 tablet:items-center", children: [
  /* @__PURE__ */ e(
    r,
    {
      className: "leading-tight tablet:max-w-[30ch] tablet:text-center",
      level: "1",
      tagName: "h2",
      children: "Why partner with Frontend Mentor?"
    }
  ),
  /* @__PURE__ */ a("ul", { className: "gap-5 grid grid-cols-1 tablet:max-w-prose desktop:grid-cols-3 desktop:max-w-none", children: [
    /* @__PURE__ */ a(
      t,
      {
        className: "flex flex-col gap-6 mx-auto p-5 desktop:col-span-3 desktop:flex-row-reverse desktop:gap-7 desktop:items-center desktop:max-w-none",
        tagName: "li",
        children: [
          /* @__PURE__ */ e(
            s,
            {
              alt: "",
              className: "desktop:w-1/2",
              height: 645,
              src: "https://res.cloudinary.com/dz209s6jk/image/upload/v1739976190/DesignSystem/become-a-partner-1.webp",
              width: 810
            }
          ),
          /* @__PURE__ */ a("div", { className: "flex flex-col gap-5 desktop:w-1/2", children: [
            /* @__PURE__ */ a("div", { className: "flex flex-col gap-4", children: [
              /* @__PURE__ */ e(r, { level: "4", tagName: "h3", children: "Earn on three platforms" }),
              /* @__PURE__ */ e("p", { className: "text-lg text-neutral-500", children: "Generate recurring commissions across Frontend Mentor’s entire product suite." })
            ] }),
            /* @__PURE__ */ a("ul", { className: "flex flex-col gap-5", children: [
              /* @__PURE__ */ a("li", { className: "flex flex-col gap-1 items-start", children: [
                /* @__PURE__ */ a(
                  "a",
                  {
                    className: "flex gap-3 group items-center text-lg text-blue-500",
                    href: process.env.NEXT_PUBLIC_LEARNING_PLATFORM_URL,
                    target: "_blank",
                    children: [
                      /* @__PURE__ */ a("span", { className: "group-hover:underline", children: [
                        "Frontend Mentor",
                        " ",
                        /* @__PURE__ */ e("span", { className: "sr-only", children: "(Opens in a new tab)" })
                      ] }),
                      /* @__PURE__ */ e(l, { name: "arrow-up-right" })
                    ]
                  }
                ),
                /* @__PURE__ */ e("span", { children: "Help developers improve their coding skills by building realistic projects." })
              ] }),
              /* @__PURE__ */ a("li", { className: "flex flex-col gap-1 items-start", children: [
                /* @__PURE__ */ a(
                  "a",
                  {
                    className: "flex gap-3 group items-center text-lg text-blue-500",
                    href: process.env.NEXT_PUBLIC_TEAMS_PLATFORM_URL,
                    target: "_blank",
                    children: [
                      /* @__PURE__ */ a("span", { className: "group-hover:underline", children: [
                        "Frontend Mentor for Teams",
                        " ",
                        /* @__PURE__ */ e("span", { className: "sr-only", children: "(Opens in a new tab)" })
                      ] }),
                      /* @__PURE__ */ e(l, { name: "arrow-up-right" })
                    ]
                  }
                ),
                /* @__PURE__ */ e("span", { children: "Help companies and schools train and onboard developers faster with project-based learning." })
              ] }),
              /* @__PURE__ */ a("li", { className: "flex flex-col gap-1 items-start", children: [
                /* @__PURE__ */ a(
                  "a",
                  {
                    className: "flex gap-3 group items-center text-lg text-blue-500",
                    href: process.env.NEXT_PUBLIC_HIRING_PLATFORM_URL,
                    target: "_blank",
                    children: [
                      /* @__PURE__ */ a("span", { className: "group-hover:underline", children: [
                        "Frontend Mentor for Hiring",
                        " ",
                        /* @__PURE__ */ e("span", { className: "sr-only", children: "(Opens in a new tab)" })
                      ] }),
                      /* @__PURE__ */ e(l, { name: "arrow-up-right" })
                    ]
                  }
                ),
                /* @__PURE__ */ e("span", { children: "Help companies hire exceptional, project-proven early-career developers from the Frontend Mentor community." })
              ] })
            ] })
          ] })
        ]
      }
    ),
    /* @__PURE__ */ a(t, { className: "flex flex-col gap-4 p-5", tagName: "li", children: [
      /* @__PURE__ */ e("span", { className: "aspect-square bg-blue-100 flex-center rounded-lg w-[4.5rem]", children: /* @__PURE__ */ e(l, { className: "text-blue-500 text-2xl", name: "sack-dollar" }) }),
      /* @__PURE__ */ e(r, { level: "5", tagName: "h3", children: "Recurring 30% commission" }),
      /* @__PURE__ */ e("p", { className: "text-neutral-500", children: "Every time someone signs up through your unique link or code, you’ll receive a 30% share of the sale and any subsequent renewals." })
    ] }),
    /* @__PURE__ */ a(t, { className: "flex flex-col gap-4 p-5", tagName: "li", children: [
      /* @__PURE__ */ e("span", { className: "aspect-square bg-blue-100 flex-center rounded-lg w-[4.5rem]", children: /* @__PURE__ */ e(l, { className: "text-blue-500 text-2xl", name: "calendar-star" }) }),
      /* @__PURE__ */ e(r, { level: "5", tagName: "h3", children: "Monthly payouts" }),
      /* @__PURE__ */ e("p", { className: "text-neutral-500", children: "We process partner earnings on a reliable monthly schedule, ensuring you get paid promptly for your referrals." })
    ] }),
    /* @__PURE__ */ a(t, { className: "flex flex-col gap-4 p-5", tagName: "li", children: [
      /* @__PURE__ */ e("span", { className: "aspect-square bg-blue-100 flex-center rounded-lg w-[4.5rem]", children: /* @__PURE__ */ e(l, { className: "text-blue-500 text-2xl", name: "rocket" }) }),
      /* @__PURE__ */ e(r, { level: "5", tagName: "h3", children: "Easy to get started" }),
      /* @__PURE__ */ e("p", { className: "text-neutral-500", children: "Simply share Frontend Mentor with your audience. We’ll provide resources, ongoing support, and transparent referral tracking—all you need to do is focus on creating great content." })
    ] })
  ] })
] });
export {
  d as default
};
